<!-- src/components/ezer/EzerHeader.vue -->
<template>
  <div class="ezer-header" @click="isMinimized ? $emit('restore') : null">
    <div class="ezer-header__brand">
      <span class="ezer-header__logo">
        <svg viewBox="0 0 20 20" width="20" height="20" fill="currentColor">
          <path d="M10 1a6 6 0 0 1 6 6v1a6 6 0 0 1-3 5.2V16a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 7 16v-2.8A6 6 0 0 1 4 8V7a6 6 0 0 1 6-6z"/>
          <rect x="7" y="18" width="6" height="1.5" rx=".75"/>
        </svg>
      </span>
      <div class="ezer-header__text">
        <span class="ezer-header__title">Ezer AI</span>
        <span class="ezer-header__subtitle">Your scheduling assistant</span>
      </div>
    </div>

    <div class="ezer-header__actions">
      <button
        v-if="!isMinimized"
        class="ezer-header__btn"
        @click.stop="$emit('clear')"
        title="New conversation"
        aria-label="New conversation"
      >
        <svg viewBox="0 0 20 20" width="16" height="16" fill="currentColor"><path d="M10 3a1 1 0 0 1 1 1v5h5a1 1 0 1 1 0 2h-5v5a1 1 0 1 1-2 0v-5H4a1 1 0 1 1 0-2h5V4a1 1 0 0 1 1-1z"/></svg>
      </button>
      <button
        class="ezer-header__btn"
        @click.stop="isMinimized ? $emit('restore') : $emit('minimize')"
        :title="isMinimized ? 'Restore' : 'Minimize'"
        :aria-label="isMinimized ? 'Restore' : 'Minimize'"
      >
        <svg v-if="!isMinimized" viewBox="0 0 20 20" width="16" height="16" fill="currentColor"><path d="M4 10h12a1 1 0 1 0 0-2H4a1 1 0 1 0 0 2z"/></svg>
        <svg v-else viewBox="0 0 20 20" width="16" height="16" fill="currentColor"><path d="M3 5h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>
      </button>
      <button
        class="ezer-header__btn ezer-header__btn--close"
        @click.stop="$emit('close')"
        title="Close"
        aria-label="Close"
      >
        <svg viewBox="0 0 20 20" width="16" height="16" fill="currentColor"><path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22z"/></svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EzerHeader',
  props: { isMinimized: Boolean },
  emits: ['minimize', 'restore', 'close', 'clear'],
}
</script>
